/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 无数据列表 的 **请求配置**
 *
 * @分类 仓储API/商品/无数据商品
 * @请求头 `POST /erp/NoDataGoods/noDataGoodsList`
 */
const postNoDataGoodsListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/NoDataGoods/noDataGoodsList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postNoDataGoodsList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 无数据列表 的 **请求函数**
 *
 * @分类 仓储API/商品/无数据商品
 * @请求头 `POST /erp/NoDataGoods/noDataGoodsList`
 */
export const postNoDataGoodsList = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postNoDataGoodsListRequestConfig, requestData),
    ...args
  );
};
postNoDataGoodsList.requestConfig = postNoDataGoodsListRequestConfig;
/**
 * 接口 根据无数据id获取详情 的 **请求配置**
 *
 * @分类 仓储API/商品/无数据商品
 * @请求头 `POST /erp/NoDataGoods/getNoDataInfoByNdgid`
 */
const postGetNoDataInfoByNdgidRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/NoDataGoods/getNoDataInfoByNdgid",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetNoDataInfoByNdgid",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 根据无数据id获取详情 的 **请求函数**
 *
 * @分类 仓储API/商品/无数据商品
 * @请求头 `POST /erp/NoDataGoods/getNoDataInfoByNdgid`
 */
export const postGetNoDataInfoByNdgid = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetNoDataInfoByNdgidRequestConfig, requestData),
    ...args
  );
};
postGetNoDataInfoByNdgid.requestConfig = postGetNoDataInfoByNdgidRequestConfig;
/**
 * 接口 获取无数据包裹信息 的 **请求配置**
 *
 * @分类 仓储API/商品/无数据商品
 * @请求头 `POST /erp/NoDataGoods/getPackageNoShippingInfo`
 */
const postGetPackageNoShippingInfoRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/NoDataGoods/getPackageNoShippingInfo",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetPackageNoShippingInfo",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取无数据包裹信息 的 **请求函数**
 *
 * @分类 仓储API/商品/无数据商品
 * @请求头 `POST /erp/NoDataGoods/getPackageNoShippingInfo`
 */
export const postGetPackageNoShippingInfo = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetPackageNoShippingInfoRequestConfig, requestData),
    ...args
  );
};
postGetPackageNoShippingInfo.requestConfig =
  postGetPackageNoShippingInfoRequestConfig;
/**
 * 接口 填写退还快递单号 的 **请求配置**
 *
 * @分类 仓储API/商品/无数据商品
 * @请求头 `POST /erp/NoDataGoods/saveShippingNum`
 */
const postSaveShippingNumRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/NoDataGoods/saveShippingNum",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSaveShippingNum",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 填写退还快递单号 的 **请求函数**
 *
 * @分类 仓储API/商品/无数据商品
 * @请求头 `POST /erp/NoDataGoods/saveShippingNum`
 */
export const postSaveShippingNum = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postSaveShippingNumRequestConfig, requestData),
    ...args
  );
};
postSaveShippingNum.requestConfig = postSaveShippingNumRequestConfig;
/**
 * 接口 批量撤回放行退还 的 **请求配置**
 *
 * @分类 仓储API/商品/无数据商品
 * @请求头 `POST /erp/NoDataGoods/withdrawBackToSupply`
 */
const postWithdrawBackToSupplyRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/NoDataGoods/withdrawBackToSupply",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postWithdrawBackToSupply",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 批量撤回放行退还 的 **请求函数**
 *
 * @分类 仓储API/商品/无数据商品
 * @请求头 `POST /erp/NoDataGoods/withdrawBackToSupply`
 */
export const postWithdrawBackToSupply = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postWithdrawBackToSupplyRequestConfig, requestData),
    ...args
  );
};
postWithdrawBackToSupply.requestConfig = postWithdrawBackToSupplyRequestConfig;
const mockUrl_0_0_0_1 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_1 = "";
const prodUrl_0_0_0_1 = "";
const dataKey_0_0_0_1 = "data";
/**
 * 接口 无数据包裹图片更新 的 **请求配置**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/NoDataGoods/saveNoDataPackageImg`
 */
const postSaveNoDataPackageImgRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/NoDataGoods/saveNoDataPackageImg",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSaveNoDataPackageImg",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 无数据包裹图片更新 的 **请求函数**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/NoDataGoods/saveNoDataPackageImg`
 */
export const postSaveNoDataPackageImg = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postSaveNoDataPackageImgRequestConfig, requestData),
    ...args
  );
};
postSaveNoDataPackageImg.requestConfig = postSaveNoDataPackageImgRequestConfig;
/**
 * 接口 无数据包裹图片获取 的 **请求配置**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/NoDataGoods/getNoDataPackageImg`
 */
const postGetNoDataPackageImgRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/NoDataGoods/getNoDataPackageImg",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetNoDataPackageImg",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 无数据包裹图片获取 的 **请求函数**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/NoDataGoods/getNoDataPackageImg`
 */
export const postGetNoDataPackageImg = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postGetNoDataPackageImgRequestConfig, requestData),
    ...args
  );
};
postGetNoDataPackageImg.requestConfig = postGetNoDataPackageImgRequestConfig;
/**
 * 接口 无数据商品列表-移交采购 的 **请求配置**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/NoDataGoods/moveToPurchase`
 */
const postMoveToPurchaseRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/NoDataGoods/moveToPurchase",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postMoveToPurchase",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 无数据商品列表-移交采购 的 **请求函数**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/NoDataGoods/moveToPurchase`
 */
export const postMoveToPurchase = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postMoveToPurchaseRequestConfig, requestData),
    ...args
  );
};
postMoveToPurchase.requestConfig = postMoveToPurchaseRequestConfig;
/**
 * 接口 无数据商品列表-获取枚举 的 **请求配置**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/NoDataGoods/getNoDataGoodsListFilter`
 */
const postGetNoDataGoodsListFilterRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/NoDataGoods/getNoDataGoodsListFilter",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetNoDataGoodsListFilter",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 无数据商品列表-获取枚举 的 **请求函数**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/NoDataGoods/getNoDataGoodsListFilter`
 */
export const postGetNoDataGoodsListFilter = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetNoDataGoodsListFilterRequestConfig, requestData),
    ...args
  );
};
postGetNoDataGoodsListFilter.requestConfig =
  postGetNoDataGoodsListFilterRequestConfig;
/**
 * 接口 无数据打标-理由数据 的 **请求配置**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `GET /erp/NoDataGoods/getNoDataGoodsReason`
 */
const getGetNoDataGoodsReasonRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/NoDataGoods/getNoDataGoodsReason",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getGetNoDataGoodsReason",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 无数据打标-理由数据 的 **请求函数**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `GET /erp/NoDataGoods/getNoDataGoodsReason`
 */
export const getGetNoDataGoodsReason = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(getGetNoDataGoodsReasonRequestConfig, requestData),
    ...args
  );
};
getGetNoDataGoodsReason.requestConfig = getGetNoDataGoodsReasonRequestConfig;
/**
 * 接口 无数据点货-新建无数据商品 的 **请求配置**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/NoDataGoods/createNoDataGoodsId`
 */
const postCreateNoDataGoodsIdRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/NoDataGoods/createNoDataGoodsId",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postCreateNoDataGoodsId",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 无数据点货-新建无数据商品 的 **请求函数**
 *
 * @分类 旧接口文档/仓库基本配置
 * @请求头 `POST /erp/NoDataGoods/createNoDataGoodsId`
 */
export const postCreateNoDataGoodsId = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postCreateNoDataGoodsIdRequestConfig, requestData),
    ...args
  );
};
postCreateNoDataGoodsId.requestConfig = postCreateNoDataGoodsIdRequestConfig;
const mockUrl_0_0_0_2 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_2 = "";
const prodUrl_0_0_0_2 = "";
const dataKey_0_0_0_2 = "data";
/**
 * 接口 撤销包裹号 的 **请求配置**
 *
 * @分类 旧接口文档/无数据包裹
 * @请求头 `POST /erp/NoDataGoods/cloneNoDataPackageByPackageNo`
 */
const postCloneNoDataPackageByPackageNoRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/NoDataGoods/cloneNoDataPackageByPackageNo",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postCloneNoDataPackageByPackageNo",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 撤销包裹号 的 **请求函数**
 *
 * @分类 旧接口文档/无数据包裹
 * @请求头 `POST /erp/NoDataGoods/cloneNoDataPackageByPackageNo`
 */
export const postCloneNoDataPackageByPackageNo = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postCloneNoDataPackageByPackageNoRequestConfig, requestData),
    ...args
  );
};
postCloneNoDataPackageByPackageNo.requestConfig =
  postCloneNoDataPackageByPackageNoRequestConfig;
/**
 * 接口 无数据商品放行退还,并打印无数据包裹号 的 **请求配置**
 *
 * @分类 旧接口文档/无数据包裹
 * @请求头 `POST /erp/NoDataGoods/makeNoDataPackageBackToSupply`
 */
const postMakeNoDataPackageBackToSupplyRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/NoDataGoods/makeNoDataPackageBackToSupply",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postMakeNoDataPackageBackToSupply",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 无数据商品放行退还,并打印无数据包裹号 的 **请求函数**
 *
 * @分类 旧接口文档/无数据包裹
 * @请求头 `POST /erp/NoDataGoods/makeNoDataPackageBackToSupply`
 */
export const postMakeNoDataPackageBackToSupply = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postMakeNoDataPackageBackToSupplyRequestConfig, requestData),
    ...args
  );
};
postMakeNoDataPackageBackToSupply.requestConfig =
  postMakeNoDataPackageBackToSupplyRequestConfig;
/**
 * 接口 获取无数据包裹打印面单 的 **请求配置**
 *
 * @分类 旧接口文档/无数据包裹
 * @请求头 `POST /erp/NoDataGoods/getNoDataPackagePrintInfo`
 */
const postGetNoDataPackagePrintInfoRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/NoDataGoods/getNoDataPackagePrintInfo",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetNoDataPackagePrintInfo",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取无数据包裹打印面单 的 **请求函数**
 *
 * @分类 旧接口文档/无数据包裹
 * @请求头 `POST /erp/NoDataGoods/getNoDataPackagePrintInfo`
 */
export const postGetNoDataPackagePrintInfo = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetNoDataPackagePrintInfoRequestConfig, requestData),
    ...args
  );
};
postGetNoDataPackagePrintInfo.requestConfig =
  postGetNoDataPackagePrintInfoRequestConfig;
/**
 * 接口 获取驻点打印小程序二维码 的 **请求配置**
 *
 * @分类 旧接口文档/无数据包裹
 * @请求头 `POST /erp/NoDataGoods/getNoDataPackageScanPage`
 */
const postGetNoDataPackageScanPageRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/NoDataGoods/getNoDataPackageScanPage",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetNoDataPackageScanPage",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取驻点打印小程序二维码 的 **请求函数**
 *
 * @分类 旧接口文档/无数据包裹
 * @请求头 `POST /erp/NoDataGoods/getNoDataPackageScanPage`
 */
export const postGetNoDataPackageScanPage = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetNoDataPackageScanPageRequestConfig, requestData),
    ...args
  );
};
postGetNoDataPackageScanPage.requestConfig =
  postGetNoDataPackageScanPageRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/noDataGoods.js